import { IonItem, IonModal, IonTitle, IonButton, IonHeader } from "@ionic/react"
import { useState } from "react"
import { API_URL } from "../../../../actions/settings"
import NotificationPopUp from "../../../extras/NotificationPopUp"
import AE2Input from "../../../elements/AE2Input"

interface Props{
    opened:boolean,
    setShowTSAreaModal:any,
    setTSArea:any
}

async function addTSArea(data:any,token:any) {

    return fetch(`${API_URL}/ts_area`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization':token
      },
      body: JSON.stringify(data)

    })
      .then(data => data.json())
   }


const startForm = {
    "name": "",
}
const errorsForm:any = {
    "name": "",
}

const TSAreaForm:React.FC<Props> = ({opened,setShowTSAreaModal,setTSArea}) =>{
    const [form, setForm] = useState(startForm)
    const [errors, setErrors] = useState(errorsForm)

    const validate = (name:string, val:any) => {
        switch (name) {
            case 'name':
                if(val === null || val.length <=1){
                    return {name:'Name Must Be Longer Than 2 Characters'}
                }
                else{
                    return {name:''}
                }

            default:
                break;
        }
    }

    const validateAll = (form:any) => {
        let validation = errorsForm
        let valid = true
        for (let item in form){

            validation = {...validation, ...validate(item,form[item])}

        }
        setErrors({...errors,...validation})

        for(let val in validation){
            if (validation[val] !== ''){
                valid = false;
            }

        }

        return valid
        }

    const handleFormChange = (value:any,name:string) => {
        setErrors({...errors, ...validate(name,value) })
        setForm((prevState) => {
            return {
                ...prevState,
                [name]:value
            }
        } )
    }

    const handleSubmit = async (form:any) => {
        const token:any = localStorage.getItem('token')
        const valid = validateAll(form) || false
        if(valid){
        const res = await addTSArea(form,`Token ${token.slice(1,-1)}`)
            if (res.status === "success"){
                setShowTSAreaModal(false)
                setForm(startForm)
                setTSArea((prevState:any) => {
                    return [
                        ...prevState,
                        res.data
                    ]
                })
                NotificationPopUp('success','Service Type Added')

            }
            else{
                NotificationPopUp('Error',res.detail||res.ERROR,res.error)
            }
        }
    }

    return (
        <IonModal id="serviceTypeModal" isOpen={opened} onDidDismiss={()=>setShowTSAreaModal(false)}>
                <IonHeader><IonTitle>Add Technical Solution Area Form</IonTitle></IonHeader>
                    <form>
                        <IonItem>
                            <AE2Input label='Technical Solution Area Name::' labelPlacement='floating' errorText={errors.name} value={form.name} placeholder="TS Area Name" onIonInput={(e)=> handleFormChange(e.detail.value!,'name')}></AE2Input>
                        </IonItem>
                    </form>
                    <div className='buttons'>
                    <IonButton onClick={()=>handleSubmit(form)} >Add</IonButton>
                    <IonButton onClick={()=>setShowTSAreaModal(false)} color='danger'>cancel</IonButton>
                    </div>
            </IonModal>
    )
}

export default TSAreaForm